package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.CelebrationW500Rounded: ImageVector
    get() {
        if (_celebrationW500Rounded != null) {
            return _celebrationW500Rounded!!
        }
        _celebrationW500Rounded = Builder(name = "CelebrationW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(221.09f, 744.65f)
                lineTo(492.8f, 648.0f)
                lineTo(317.74f, 472.93f)
                lineToRelative(-96.65f, 271.72f)
                close()
                moveTo(926.98f, 287.93f)
                quadToRelative(-9.24f, 9.24f, -21.72f, 9.24f)
                quadToRelative(-12.48f, 0.0f, -21.72f, -9.24f)
                lineToRelative(-2.28f, -2.28f)
                quadToRelative(-14.0f, -14.0f, -35.0f, -14.0f)
                reflectiveQuadToRelative(-35.0f, 14.0f)
                lineTo(614.0f, 482.91f)
                quadToRelative(-9.72f, 9.72f, -22.67f, 9.6f)
                quadToRelative(-12.96f, -0.12f, -22.68f, -9.84f)
                quadToRelative(-9.72f, -9.71f, -9.72f, -22.79f)
                quadToRelative(0.0f, -13.08f, 9.72f, -22.79f)
                lineToRelative(197.02f, -197.02f)
                quadToRelative(33.44f, -33.44f, 80.71f, -33.44f)
                quadToRelative(47.27f, 0.0f, 80.71f, 33.44f)
                lineToRelative(2.28f, 2.28f)
                quadToRelative(9.24f, 9.24f, 8.88f, 21.95f)
                quadToRelative(-0.36f, 12.72f, -11.27f, 23.63f)
                close()
                moveTo(398.28f, 152.63f)
                quadToRelative(9.48f, -9.48f, 22.2f, -9.48f)
                quadToRelative(12.72f, 0.0f, 22.19f, 9.48f)
                lineToRelative(3.81f, 3.8f)
                quadToRelative(33.43f, 33.44f, 33.43f, 79.71f)
                quadToRelative(0.0f, 46.27f, -33.43f, 79.71f)
                lineToRelative(-2.28f, 2.28f)
                quadToRelative(-8.77f, 8.76f, -21.0f, 8.04f)
                quadToRelative(-12.24f, -0.71f, -24.59f, -13.3f)
                quadToRelative(-8.76f, -8.76f, -8.76f, -20.28f)
                quadToRelative(0.0f, -11.52f, 8.76f, -20.29f)
                lineToRelative(2.28f, -2.28f)
                quadToRelative(14.0f, -14.0f, 14.0f, -34.0f)
                reflectiveQuadToRelative(-14.0f, -34.0f)
                lineToRelative(-3.8f, -3.8f)
                quadToRelative(-9.48f, -9.48f, -9.24f, -22.44f)
                quadToRelative(0.24f, -12.95f, 10.43f, -23.15f)
                close()
                moveTo(561.96f, 78.37f)
                quadToRelative(9.71f, -9.72f, 22.91f, -9.6f)
                quadToRelative(13.2f, 0.12f, 22.91f, 9.84f)
                lineToRelative(41.09f, 41.09f)
                quadToRelative(33.43f, 33.43f, 33.43f, 80.58f)
                reflectiveQuadToRelative(-33.43f, 80.59f)
                lineTo(530.41f, 399.33f)
                quadToRelative(-9.71f, 9.71f, -22.79f, 9.71f)
                quadToRelative(-13.08f, 0.0f, -22.79f, -9.71f)
                quadToRelative(-9.72f, -9.72f, -9.72f, -22.92f)
                quadToRelative(0.0f, -13.19f, 9.72f, -22.91f)
                lineToRelative(118.21f, -118.22f)
                quadToRelative(14.0f, -14.0f, 14.0f, -35.0f)
                reflectiveQuadToRelative(-14.0f, -35.0f)
                lineToRelative(-41.08f, -41.08f)
                quadToRelative(-9.72f, -9.72f, -9.72f, -22.92f)
                quadToRelative(0.0f, -13.19f, 9.72f, -22.91f)
                close()
                moveTo(894.39f, 567.93f)
                quadToRelative(-9.72f, 9.72f, -22.91f, 9.72f)
                quadToRelative(-13.2f, 0.0f, -22.91f, -9.72f)
                lineToRelative(-41.09f, -41.08f)
                quadToRelative(-14.0f, -14.0f, -35.0f, -14.0f)
                reflectiveQuadToRelative(-35.0f, 14.0f)
                lineToRelative(-39.65f, 39.65f)
                quadToRelative(-9.72f, 9.72f, -22.92f, 9.72f)
                quadToRelative(-13.19f, 0.0f, -22.91f, -9.72f)
                reflectiveQuadToRelative(-9.6f, -22.91f)
                quadToRelative(0.12f, -13.2f, 9.84f, -22.92f)
                lineToRelative(39.65f, -39.65f)
                quadToRelative(33.44f, -33.43f, 80.71f, -33.43f)
                quadToRelative(47.27f, 0.0f, 80.7f, 33.43f)
                lineToRelative(41.09f, 41.09f)
                quadToRelative(9.72f, 9.72f, 9.72f, 22.91f)
                quadToRelative(0.0f, 13.2f, -9.72f, 22.91f)
                close()
                moveTo(221.09f, 744.65f)
                close()
                moveTo(102.98f, 803.83f)
                lineTo(256.85f, 374.98f)
                quadToRelative(5.72f, -14.68f, 17.65f, -22.63f)
                quadToRelative(11.93f, -7.96f, 25.61f, -7.96f)
                quadToRelative(8.96f, 0.0f, 16.91f, 3.24f)
                quadToRelative(7.96f, 3.24f, 14.91f, 10.2f)
                lineTo(607.91f, 633.8f)
                quadToRelative(6.96f, 6.96f, 10.2f, 14.92f)
                quadToRelative(3.24f, 7.95f, 3.24f, 16.91f)
                quadToRelative(0.0f, 13.67f, -7.96f, 25.49f)
                quadToRelative(-7.95f, 11.81f, -22.63f, 17.53f)
                lineTo(161.67f, 862.52f)
                quadToRelative(-13.91f, 5.48f, -26.34f, 1.62f)
                quadToRelative(-12.44f, -3.86f, -21.4f, -12.81f)
                quadToRelative(-8.95f, -8.96f, -12.69f, -21.4f)
                quadToRelative(-3.74f, -12.43f, 1.74f, -26.1f)
                close()
            }
        }
        .build()
        return _celebrationW500Rounded!!
    }

private var _celebrationW500Rounded: ImageVector? = null
